import axios from 'axios';
import { extractDownloadFilename, triggerBlobDownload } from './exportScreensExcel';

/**
 * @param {'manual'|'package'} campaignType
 * @param {Record<string, unknown>} payload
 */
export async function exportCampaignSettings(campaignType, payload) {
    const url = campaignType === 'package'
        ? '/rtb/package-campaigns/settings/export'
        : campaignType === 'poi'
            ? '/rtb/poi-campaigns/settings/export'
            : '/rtb/campaigns/settings/export';

    const response = await axios.post(url, payload, {
        responseType: 'blob',
        headers: {
            Accept: 'application/json',
        },
    });

    const filename = extractDownloadFilename(response)
        || `rtb-${campaignType}-settings-${new Date().toISOString().slice(0, 10)}.json`;
    triggerBlobDownload(response.data, filename);

    return { ok: true, filename };
}

/**
 * @param {'manual'|'package'} campaignType
 * @param {File} file
 * @returns {Promise<{ payload: Record<string, unknown>, warnings: string[] }>}
 */
export async function importCampaignSettings(campaignType, file) {
    const url = campaignType === 'package'
        ? '/rtb/package-campaigns/settings/import'
        : campaignType === 'poi'
            ? '/rtb/poi-campaigns/settings/import'
            : '/rtb/campaigns/settings/import';

    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    return {
        payload: response.data.payload || {},
        warnings: Array.isArray(response.data.warnings) ? response.data.warnings : [],
    };
}
